import { render, staticRenderFns } from "./MyProfileTabs.vue?vue&type=template&id=3f0f6bcb"
import script from "./MyProfileTabs.vue?vue&type=script&lang=js"
export * from "./MyProfileTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports